services.factory('InvestCalcService', ['constants', 'AssetService', 'CurrencyConvertService',

    function (Const, AssetService, CurrencyConvertService) {

        function getPoints(val, digits) {
            return val * (1 / Math.pow(10, digits));
        }

        function fromPoints(val, digits) {
            return val * Math.pow(10, digits);
        }

        function getCurrentPrice(action, Asset) {
            return (action === 'sell' || action === 'sell_limit' || action === 'sell_stop') ?
                Asset.markupBid() :
                Asset.markupAsk()
        }

        function getUpdatedPrice(action, Asset) {
            switch (action) {
            case 'sell':
                return Asset.markupAsk();
                break;
            case 'buy':
                return Asset.markupBid();
                break;
            default:
                return getCurrentPrice(action, Asset);
                break;
            }
        }

        function getOpenPrice(action, Asset) {
            switch (action) {
            case 'sell':
            case 'sell_limit':
            case 'sell_stop':
                return Asset.markupBid();
                break;
            case 'buy':
            case 'buy_limit':
            case 'buy_stop':
                return Asset.markupAsk();
                break;
            }
        }

        function getClosePriceFromPoints(action, Asset, openPrice, pointsRateVal, sltp) {
            var points = getPoints(pointsRateVal, Asset.digits);

            switch (action) {
            case 'sell':
            case 'sell_limit':
            case 'sell_stop':
                return sltp === "stopLoss" ? openPrice + points : openPrice - points;
            case 'buy':
            case 'buy_limit':
            case 'buy_stop':
                return sltp === "stopLoss" ? openPrice - points : openPrice + points;
                break;
            }
        }

        function getPairVal(action, openPrice, closePrice, digits) {
            openPrice = Math.round(fromPoints(openPrice, digits));
            closePrice = Math.round(fromPoints(closePrice, digits));
            switch (action) {
                case 'sell':
                case 'sell_limit':
                case 'sell_stop':
                    return getPoints(openPrice - closePrice, digits);
                case 'buy':
                case 'buy_limit':
                case 'buy_stop':
                    return getPoints(closePrice - openPrice, digits);
            }
        }

        function getSymbolCurrency(currency, isUSD) {
            return isUSD ?
                AssetService.collection.get({outputName: 'USD' + Const.currencySeparator + currency}) :
                AssetService.collection.get({outputName: currency + Const.currencySeparator + 'USD'});
        }

        function getRequiredMargin(investAmount, Asset, User, action) {
            var marketPrice = action && action === 'buy' ? Asset.markupAsk() : Asset.markupBid(),
                leverage = (User.activeTradingAccount && User.activeTradingAccount.leverage) || User.leverage,
                percentage = Asset.percentage / 100,
                lotsContractSize = investAmount * Asset.contractSize,
                marginMode = (Asset.marginMode === 1 && Asset.profitMode === 0) ? 99 : Asset.marginMode;
            // 99 is custom value for calculate requireMargin for esma assets
            if(marginMode !== 2 && Asset.initialMargin > 0) {
                var lotInitialMargin =  investAmount * Asset.initialMargin;
                return  (marginMode === 0 || marginMode === 4) ? lotInitialMargin / leverage : lotInitialMargin;
            }
            switch (marginMode) {
                case 0:
                    return lotsContractSize / leverage * percentage;
                case 1:
                    return lotsContractSize * marketPrice * percentage;
                case 2:
                    return investAmount * Asset.initialMargin * percentage;
                case 3:
                    return lotsContractSize * (marketPrice * (Asset.tickPrice / Asset.tickSize)) * percentage;
                case 4:
                    return (lotsContractSize * marketPrice) / leverage * percentage;
                case 5:
                case 99:
                    return lotsContractSize * percentage;
            }
        }

        function calcMargin(investAmount, action, asset, user, swapValue) {
            var convertedCurrency,
                baseVal = 0,
                requiredMargin,
                convertAssets = swapValue && asset.swapsCode && asset.swapsCode === 2 ? asset.convAssets : asset.convAssetsMargin;

            if (typeof swapValue !== 'undefined') {
                requiredMargin = swapValue;
            } else {
                requiredMargin = getRequiredMargin(parseFloat(investAmount) || 1, asset, user, action);
            }
            baseVal = CurrencyConvertService.doConvert(convertAssets, requiredMargin, action, asset.profitMode);
            return {baseVal: baseVal, requiredMargin: requiredMargin}
        }

        function calcLeverage(asset, margin) {
            return (asset.profitMode === 0) ?
                Math.ceil(asset.contractSize / margin) :
                Math.ceil((asset.contractSize * asset.markupBid()) / margin);
        }

        function getPipsLimit(asset) {
            var spread = (asset.markupAsk() - asset.markupBid()) * Math.pow(10, asset.digits),
                pipsLimit = (spread + asset.stopLevels) / 10;
            return Math.ceil(pipsLimit);
        }

        return {
            updatedPrice: getUpdatedPrice,
            currentPrice: getCurrentPrice,
            getSymbolCurrency: getSymbolCurrency,
            fromPoints: fromPoints,
            getPoints: getPoints,
            getOpenPrice: getOpenPrice,
            getClosePrice: getClosePriceFromPoints,
            getPairVal: getPairVal,
            getRequiredMargin: getRequiredMargin,
            calcMargin: calcMargin,
            calcLeverage: calcLeverage,
            getPipsLimit: getPipsLimit
        }

    }]);
